import { render, staticRenderFns } from "./AddOnSelector.vue?vue&type=template&id=6f531f01&"
import script from "./AddOnSelector.vue?vue&type=script&lang=ts&"
export * from "./AddOnSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports